export default __webpack_public_path__ + "static/media/explore-2.6b186a34.png";